// extracted by mini-css-extract-plugin
module.exports = {"sectionL":"SectionL_sectionL__tc316"};